import { render, staticRenderFns } from "./OsDetails.vue?vue&type=template&id=16b089b6&scoped=true&"
import script from "./OsDetails.vue?vue&type=script&lang=js&"
export * from "./OsDetails.vue?vue&type=script&lang=js&"
import style0 from "./OsDetails.vue?vue&type=style&index=0&id=16b089b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b089b6",
  null
  
)

export default component.exports